import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";

export class GetAvailableCompaniesQuery {
  constructor(
    private readonly dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(companyId:Number|String): Promise<any> {
    let res = undefined
    try {
      res = await this.dispatcher.dispatch('get.available.companies', {current_company_id: companyId});
    } catch (error) {
      console.log('Error while getting available companies: ', error);
    }
    this.frontend.availableCompanies = res || [];
  }
}